import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTheme } from 'styled-components';
import { ValueAmount } from '../../../value/amount/value-amount';
import { PortfolioMobxDto } from '../../../../../models/mobx/dtos/portfolio/portfolio-mobx-dto';
import { normalizePortfolioValue } from '../../../../../utils/normalize-portfolio-value';

type AssetMiniStocksType = {
    data: PortfolioMobxDto;
};

export const AssetMiniStocks: React.FC<AssetMiniStocksType> = observer(({ data }) => {
    const theme = useTheme();

    return (
        <div className="flex items-center justify-between gap-xsmall">
            <div className="flex items-center gap-[0.8rem]">
                <i
                    className="relative inline-flex h-[1.6rem] w-[1.6rem] items-center justify-center rounded-[30rem] border-[0.2rem] transition-none"
                    style={{
                        borderColor: theme.iconPortfolio.variant[data.colorName].base.border,
                        backgroundColor: theme.iconPortfolio.variant[data.colorName].base.border,
                    }}
                />
                <div className="max-w-[15rem] overflow-hidden text-ellipsis whitespace-nowrap text-small font-semibold opacity-80">
                    Akcie
                </div>
            </div>
            <strong className="text-small">
                <ValueAmount
                    amount={normalizePortfolioValue(data.portfolioValue)}
                    nullValue={0}
                    currency={data.portfolioHistoryCurrencyCode || data.currency.code}
                    mode="pure"
                    hidable
                />
            </strong>
        </div>
    );
});
